export enum BsToastEventTypes {
  Success = 'success',
  Info = 'info',
  InfoWhite = 'infoWhite',
  InfoWhiteStayOnScreen = 'infoWhiteStay',
  Warning = 'warning',
  WarningStayOnScreen = 'warningStay',
  Error = 'error',
  ErrorStayOnScreen = 'errorStay',
}

